import { el, setChildren } from 'https://cdn.venturz.co/lib/redom.es.js';

import SaveButton from 'https://cdn.venturz.co/components/core/save-button/index.js';
import SelfDestructingMessage from 'https://cdn.venturz.co/modules/self-destructing-message/index.js';

import ModuleBase from '../module-base/index.js';

import { createFunction } from '../utilities/language.js';

import FormFieldsRenderer from './form-fields-renderer/index.js';
import {
  getFormValues
} from './utilities/index.js';
import validationUtilities from './utilities/validation.js';

class Form extends ModuleBase {

  constructor(configuration, page) {

    super(configuration, page);

    this.values = {};
    this.formId = this.configuration.options.formId;
    this.nodeId = this.configuration.id;
    this.submitButtonLabel = this.configuration.options.submitButtonLabel;
    this.successMessage = this.configuration.options.successMessage;
    this.fieldRows = this.configuration.options.fieldRows.sort((a, b) => configuration.fieldsOrder.indexOf(a._id) - configuration.fieldsOrder.indexOf(b._id));
    this.apiResponseHandler = this.configuration.options.apiResponseHandler;
    this.page = page;
    this.formStartedEventSent = false;

    this.formFieldsRenderer = new FormFieldsRenderer({
      fieldRows: this.configuration.fieldRows,
      formId: this.formId,
      page: this.page
    });

    this.submitButton = new SaveButton({
      type: 'submit',
      label: this.submitButtonLabel,
      name: this.submitButtonLabel,
      onClick: this.handleFormSubmission.bind(this)
    });

    this.el = el('form.form-main', {
      onsubmit: () => this.submitButton.el.click(),
      oninput: this.handleFormInput.bind(this)
    }, [
      el('.form-fields-container', this.formFieldsRenderer),
      el('.form-controls-container', [
        this.submitButton
      ])
    ]);

  }
  handleFormInput(event) {
    if (this.formStartedEventSent === false) {
      this.page.userObserver.pageViewObserver.emit('Form started', { Name: this.configuration.name });
      this.formStartedEventSent = true;
    }

  }

  handleFormValuesChange(values) {

    this.values = values;

  }

  async handleFormSubmission(event) {

    event.preventDefault();

    try {

      await validationUtilities.validate(this.el, this.fieldRows, this.formFieldsRenderer);

      await this.storeFormValues();
      this.page.userObserver.pageViewObserver.emit('Form submitted', { Name: this.configuration.name });
      SelfDestructingMessage.info(this.successMessage || 'Form submitted successfully!');

    } catch (exception) {

      console.log(exception);

    }

    return false;

  }

  tryHandleAPIResponse(submission) {

    try {

      const apiResponseHandler = createFunction(this.apiResponseHandler, ['page', 'form', 'submission'], () => {});

      apiResponseHandler(this.page, this, submission);

    } catch (exception) {

      console.log(exception);

    }

  }

  async storeFormValues() {

    const formValues = getFormValues(this.el, this.formFieldsRenderer, this.fieldRows);

    const page = this.page;

    const apiInterface = await page.getDependency('api-interface');

    const data = {
      observerId: page.getUserObserverId(),
      formData: formValues
    };

    const submission = await apiInterface.forms.createFormSubmission(this.formId, data);

    this.reset();

    this.tryHandleAPIResponse(submission);

  }

  reset() {

    const fieldRowsLength = this.fieldRows.length;
    const fieldViews = this.formFieldsRenderer.el.views;

    for (let index = 0; index < fieldRowsLength; index++) {

      const fieldView = fieldViews[index];

      const inputRenderer = fieldView.inputRenderer;

      inputRenderer.reset();

    }

  }

  initialize() {

    setChildren(document.getElementById(this.nodeId), [this.el]);

  }

}

export default Form;
